import React, { memo } from "react";

import type { ProgressBarViewProps } from "@intelligems/ig-types";

import { ProgressBarContextProvider } from "../ProgressBarView/context/ProgressBarContextProvider";
import { ProgressBarFactory } from "../ProgressBarView/ProgressBarFactory";

export const ProgressBarView = memo((props: ProgressBarViewProps) => {
  const { config } = props;

  switch (props.renderType) {
    case "all":
    case "desktop":
      return (
        <ProgressBarContextProvider {...props} device={config.desktop}>
          <ProgressBarFactory />
        </ProgressBarContextProvider>
      );
    case "mobile":
      return (
        <ProgressBarContextProvider {...props} device={config.mobile}>
          <ProgressBarFactory />
        </ProgressBarContextProvider>
      );
  }
});
